import ErrorIcon from '@mui/icons-material/Error'
import RefreshIcon from '@mui/icons-material/Refresh'
import WifiIcon from '@mui/icons-material/Wifi'
import WifiOffIcon from '@mui/icons-material/WifiOff'
import { Box, Typography } from '@mui/material'
import { keyframes } from '@mui/material/styles'
import React from 'react'

// 动画定义
const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`

const blink = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
`

/**
 * ConnectionStatus - Displays WebSocket connection status with animated icon and text
 *
 * @param {string} connectionState - WebSocket connection state ('connected', 'connecting', 'disconnected', 'error')
 * @param {Object} sx - Additional styles to apply
 */
export default function ConnectionStatus({ connectionState, sx = {} }) {
  const getConnectionStatus = () => {
    switch (connectionState) {
      case 'connected':
        return {
          label: 'Chat system is live',
          icon: WifiIcon,
          color: 'success.main',
          animation: `${pulse} 2s ease-in-out infinite`,
        }
      case 'connecting':
        return {
          label: 'Connecting to chat...',
          icon: RefreshIcon,
          color: 'warning.main',
          animation: `${rotate} 1s linear infinite`,
        }
      case 'disconnected':
        return {
          label: 'Chat system offline',
          icon: WifiOffIcon,
          color: 'text.secondary',
          animation: undefined,
        }
      case 'error':
        return {
          label: 'Connection error',
          icon: ErrorIcon,
          color: 'error.main',
          animation: `${blink} 1s ease-in-out infinite`,
        }
      default:
        return {
          label: 'Connection unknown',
          icon: WifiOffIcon,
          color: 'text.secondary',
          animation: undefined,
        }
    }
  }

  if (!connectionState) {
    return null
  }

  const status = getConnectionStatus()
  const StatusIcon = status.icon

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ...sx }}>
      <StatusIcon
        sx={{
          fontSize: '1rem',
          color: status.color,
          animation: status.animation,
        }}
      />
      <Typography variant="caption" sx={{ color: status.color, fontSize: '0.75rem' }}>
        {status.label}
      </Typography>
    </Box>
  )
}
